module.exports = __webpack_public_path__ + "img/pen-tool-2.723c4ff1.svg";